export function renderAppShell(root: HTMLElement): void {
  root.innerHTML = `
    <header>
      <div class="header-inner">
        <h1><a href="/" class="header-link">Customer.io <span class="header-accent">On-Call Reports</span></a></h1>
        <button id="clear-cache-btn" class="btn btn-header" type="button">Clear Cache</button>
      </div>
    </header>

    <main>
      <div class="top-grid">
        <section class="card" id="client-panel">
          <div class="card-header">
            <h2>Clients</h2>
            <span id="selected-count" class="badge">0 selected</span>
          </div>
          <div class="toolbar">
            <div class="search-wrap">
              <svg class="search-icon" viewBox="0 0 20 20" fill="currentColor" width="16" height="16">
                <path fill-rule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clip-rule="evenodd"/>
              </svg>
              <input type="text" id="filter-input" placeholder="Filter clients…" />
            </div>
            <div class="toolbar-actions">
              <button id="select-all-btn" class="btn btn-ghost" type="button">Select All</button>
              <button id="select-weekend-btn" class="btn btn-ghost" type="button">Select Weekend</button>
              <button id="deselect-all-btn" class="btn btn-ghost" type="button">Clear</button>
            </div>
          </div>
          <div id="client-list" class="client-list"></div>
        </section>

        <section class="card" id="actions-panel">
          <div class="card-header">
            <h2>Reports</h2>
          </div>

          <div class="action-card">
            <div class="action-card-body">
              <h3>Segment Report</h3>
              <p>Segment names and customer counts for each selected client.</p>
            </div>
            <button id="segment-btn" class="btn btn-primary" type="button">Run Report</button>
          </div>

          <div class="action-card">
            <div class="action-card-body">
              <h3>Campaign Reports</h3>
              <p>Active-campaign metrics for each selected client over the chosen lookback window. Journey covers the funnel; Delivery covers send/open/click counts.</p>
              <div class="inline-field">
                <label for="hours-input">Lookback</label>
                <input type="number" id="hours-input" value="4" min="1" max="720" />
                <span class="field-suffix">hours</span>
              </div>
            </div>
            <div class="action-card-buttons">
              <button id="campaign-journey-btn" class="btn btn-primary" type="button">Campaign Journey</button>
              <button id="campaign-delivery-btn" class="btn btn-primary" type="button">Campaign Delivery</button>
            </div>
          </div>
        </section>
      </div>

      <div id="loading" class="loading hidden">
        <div class="spinner"></div>
        <span>Fetching data from Customer.io…</span>
      </div>

      <section id="results-panel" class="card hidden">
        <div class="card-header">
          <h2 id="results-title">Results</h2>
          <button id="copy-summary-btn" class="btn btn-ghost hidden" type="button">
            <svg viewBox="0 0 20 20" fill="currentColor" width="14" height="14">
              <path d="M8 3a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1z"/>
              <path d="M6 3a2 2 0 00-2 2v11a2 2 0 002 2h8a2 2 0 002-2V5a2 2 0 00-2-2 3 3 0 01-3 3H9a3 3 0 01-3-3z"/>
            </svg>
            Copy Client Summary
          </button>
          <button id="show-summary-btn" class="btn btn-ghost hidden" type="button">
            <svg viewBox="0 0 20 20" fill="currentColor" width="14" height="14">
              <path fill-rule="evenodd" d="M10 4C5.522 4 1.732 6.943.458 10c1.274 3.057 5.064 6 9.542 6 4.478 0 8.268-2.943 9.542-6C18.268 6.943 14.478 4 10 4zm0 10a4 4 0 100-8 4 4 0 000 8zm0-2a2 2 0 100-4 2 2 0 000 4z" clip-rule="evenodd"/>
            </svg>
            Show Client Summary
          </button>
          <button id="export-csv-btn" class="btn btn-success hidden" type="button">
            <svg viewBox="0 0 20 20" fill="currentColor" width="14" height="14">
              <path fill-rule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clip-rule="evenodd"/>
            </svg>
            Export CSV
          </button>
        </div>
        <div id="results-container" class="table-wrap"></div>
      </section>
    </main>
  `;
}
